
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-automotive-calculators-and-tools/wheel-mag-pitch-circle-diameter-size-calculator",
      function () {
        return require("private-next-pages/online-automotive-calculators-and-tools/wheel-mag-pitch-circle-diameter-size-calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online-automotive-calculators-and-tools/wheel-mag-pitch-circle-diameter-size-calculator"])
      });
    }
  